<template>
  <router-link :tag="link ? 'a' : 'div'" :to="{ name: 'Purchase', params: { id: purchase.id } }">
    <v-icon :class="{ 'primary--text': link }">{{ icon }}</v-icon>
    <span v-if="isAppointment">
      {{ $t('purchase.title.appointment') }}
      <small>
        <date-formatter :value="callDate"></date-formatter>
      </small>
    </span>
    <span v-else-if="isCall">
      <span v-if="callInProgress">
        <minute :value="durationForInProgressCall" short></minute>
        /
        <minute :value="service.call.time_limit"></minute>
      </span>
      <span v-else-if="callNotSuccess">{{ $t(`purchase.title.callStatus.${callStatus}`, purchase.service.call) }}</span>
      <span v-else>
        {{ $t('purchase.title.call') }}
        <minute :value="duration"></minute>
        (<price :value="callPrice"></price>{{ $t('purchase.title.perMin') }})
      </span>
    </span>
    <span v-else>
      {{ purchase.offer.title }}
      <v-chip small label outline disabled class="error error--text" v-if="!purchase.accepted_at">En attente</v-chip>
      <v-chip small label outline disabled class="success success--text" v-else-if="purchase.finished_at">Terminé</v-chip>
      <v-chip small label outline disabled class="warning warning--text" v-else>En cours</v-chip>
    </span>
  </router-link>
</template>

<script>
  import Call from '@/api/call'
  import { Minute, Price, Date as DateFormatter } from '@/components/formatters'
  import purchase from '@/mixins/purchase'
  export default {
    components: {
      Minute,
      Price,
      DateFormatter
    },
    mixins: [purchase],
    props: {
      link: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        timer: null,
        date: null
      }
    },
    computed: {
      icon () {
        if (this.isAppointment) { return 'event' }
        return {
          phone: 'phone',
          prepaid_minute: 'card_giftcard',
          mail: 'email',
          service: 'room_service',
          product: 'shopping_cart'
        }[this.purchase.offer.service_type]
      },
      service () {
        return this.purchase.service
      },
      isCall () {
        return this.purchase.offer.service_type === 'phone'
      },
      isAppointment () {
        return this.service.appointment
      },
      callPrice () {
        return this.service.per_minute_price
      },
      callStatus () {
        if (this.service.call.status === 'queued') return 'in-progress'
        return this.service.call.status || 'in-progress'
      },
      callInProgress () {
        if (this.purchase.finished_at) { return false }
        if (!this.purchase.accepted_at) { return false }
        if (!this.callNotSuccess) { return false }
        if (!this.isCall) { return false }
        if (!this.service.call_id) { return false }
        return this.callStatus === 'in-progress'
      },
      callNotSuccess () {
        return this.callStatus !== 'completed'
      },
      callDate () {
        return this.purchase.service.call_at
      },
      durationForInProgressCall () {
        if (!this.timer) {
          this.timer = setInterval(_ => (this.date = new Date()), 1000)
          this.date = new Date()
        }
        return Call.durationForInProgressCall(this.purchase, this.date)
      },
      duration () {
        return Call.duration(this.purchase)
      }
    },
    destroyed () {
      clearInterval(this.timer)
      this.timer = null
    }
  }
</script>

<style scoped>
  i {
    margin-right: .5em;
    font-size: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/purchase/Title.vue